import { render, staticRenderFns } from "./EnrolmentResponseQuestion.vue?vue&type=template&id=3571b292&scoped=true"
import script from "./EnrolmentResponseQuestion.vue?vue&type=script&lang=js"
export * from "./EnrolmentResponseQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3571b292",
  null
  
)

export default component.exports